import React from "react";

// Type
import { NavigateFunction } from "react-router-dom";

/**
 * Return URLSearchParams object.
 *
 * @param {Object} data - list of the updating params
 * @param {Function} [hookAfter] - hook for modificaton of the returning onject
 * @param {Object} initSearchData - initial params
 * @returns {Object|false}
 */
export const urlParams = function(
  data?: Record<string, any> | null,
  hookAfter?: (newParams: URLSearchParams, prevParams: URLSearchParams) => void,
  initSearchData?: string
): URLSearchParams {
  const searchParamsPrev = new URLSearchParams(
    initSearchData || window.location.search
  );

  const searchParams = new URLSearchParams(
    initSearchData || window.location.search
  );

  if (!data || typeof data !== "object") {
    return searchParams;
  }

  // basic actions
  for (const key in data) {
    const val = data[key];
    if (searchParams.has(key) && !val) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, val);
    }
  }

  // hook
  if (hookAfter && typeof hookAfter === "function") {
    hookAfter(searchParams, searchParamsPrev);
  }

  return searchParams;
};

export function addQueryParamsToUrl(params: Record<string, string>, navigate: NavigateFunction) {
  const currentSearch = window.location.search;
  const queryParams = new URLSearchParams(currentSearch);

  // Add new params to the existing search params
  Object.entries(params).forEach(([key, value]) => {
    queryParams.set(key, value);
  });

  // Replace the current search params with the updated ones
  const newSearch = queryParams.toString();
  navigate(`?${newSearch}`, { replace: true });
}
